// extracted by mini-css-extract-plugin
export default {"container":"style_container__34NMH","form_control":"style_form_control__w+Qm4","quill_editor":"style_quill_editor__1zLeZ"};